import {component} from '../../form/Constant'
import {genderList, patientOptionsList, titleList} from '../patient/Constants'

export const titleHcpOptions = [
    {
        label: 'Doctor',
        value: 'doctor',
    },
    {
        label: 'Nurse',
        value: 'nurse',
    },
    {
        label: 'Carer',
        value: 'carer',
    },
]

export const hcpKeys = {
    userAccount: 'userAccount',
    username: 'username',
    email: 'email',

    basicInformation: 'basicInformation',
    title: 'title',
    firstName: 'firstName',
    lastName: 'lastName',
    gender: 'gender',
    dob: 'dob',
    avatar: 'avatar',

    contactInformation: 'contactInformation',
    address: 'address',

    hospitalInformation: 'hospitalInformation',
    hospitalId: 'hospitalId',
    hospitalName: 'hospitalName',
    hospitalNumber: 'hospitalNumber',

    roleInformation: 'roleInformation',
    roleId: 'roleId',
    role: 'role',
}

export const toPostDataKeys = [
    hcpKeys.hospitalId,
    hcpKeys.roleId,
    hcpKeys.username,
    hcpKeys.email,
    hcpKeys.title,
    hcpKeys.firstName,
    hcpKeys.lastName,
    hcpKeys.gender,
    hcpKeys.dob,
    hcpKeys.avatar,
    hcpKeys.address,
]

export const healthCareList = [
    {
        key: hcpKeys.userAccount,
        label: 'User Account',
        required: true,
        description: ' Fill in the following information to create an account',
        note: 'The account will be sent to the patient via email after completing the form',
        children: [
            {
                key: hcpKeys.username,
                label: 'Username',
                component: component.inputText,
                placeholder: 'Auto-generated if leaving blank',
                keyFilter: /^[^<>*!/^|?,+= ]+$/,
                defaultValue: '',
                transformType: 'lowercase',
            },
            {
                key: hcpKeys.email,
                label: 'Email',
                component: component.inputText,
                required: true,
                keyFilter: /^[^<>*!/^|?,+= ]+$/,
                placeholder: "Input HCP's email",
                defaultValue: '',
                transformType: 'lowercase',
            },
        ],
    },
    {
        key: hcpKeys.basicInformation,
        label: 'Basic Information',
        description: 'Fill in the Medical Staff member information details',
        required: true,
        children: [
            {
                key: hcpKeys.title,
                label: 'Title',
                component: component.dropdown,
                options: [...titleHcpOptions, ...titleList],
                defaultValue: titleHcpOptions[0].value,
            },
            {
                key: hcpKeys.firstName,
                label: 'First Name',
                component: component.inputText,
                required: true,
                placeholder: "Input HCP's first name",
            },
            {
                key: hcpKeys.lastName,
                label: 'Last Name',
                component: component.inputText,
                placeholder: "Input HCP's last name",
            },
            {
                key: hcpKeys.gender,
                label: 'Gender',
                component: component.dropdown,
                options: patientOptionsList.gender,
                defaultValue: genderList[0],
            },
            {
                key: hcpKeys.dob,
                label: 'Date of Birth',
                component: component.inputMask,
                placeholder: 'Input date of birth',
                required: true,
                showTime: false,
            },
            {
                key: hcpKeys.avatar,
                label: 'Avatar',
                component: component.fileUpload,
            },
        ],
    },
    {
        key: 'contactInformation',
        label: 'Contact Information',
        description: 'Fill in the HCP contact details.',
        children: [
            {
                key: 'address',
                hideHeader: true,
                component: component.address,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
]
